import { mapGetters, mapActions, mapMutations } from 'vuex';
import propertyPop from '@/dpp/components/propertypop/property-pop.vue';
import mvtMapOptionsPanel from '@/common/components/mvtnewmap/mvt-mapoptionspanel.vue';
import mvtMapResults from '@/common/components/mvtnewmap/mvt-mapresults.vue';
import { CustomControl } from 'vue3-google-map';
import mvtNewMap from '@/common/components/mvtnewmap/mvt-newmap.vue';


export default {
    name: 'propertyPopMap',
    inject: ['$eventBus'],
    components: { mvtNewMap, CustomControl, mvtMapResults, mvtMapOptionsPanel, propertyPop },
    props: ['popMapTypeId', 'popStreetView', 'popFilter', 'popActiveMarker'],
    data() {
        return {
            mapTypeId: -1,
            streetView: false,
            loadSold: false,
            loadPois: false,
            zoomlevel: 16,
            viewLayerPopup: false,
            noActiveLayers: false,
            streetViewAvailable: false,
        };
    },
    methods: {
        ...mapActions('dpp', ['fetchNearbySold', 'fetchNearbyPois']),
        ...mapActions('msp', ['schoolsNearProperty']),
        ...mapMutations('glb', ['updateMapType', 'updateMapDetails', 'updateSelectedPoi']),
        fetchNearbySoldHomes() {
            if (this.dpp.isRentals) {
                return null;
            }
            if (!this.dpp.nearbySoldHomes || !this.dpp.nearbySoldHomes.length) {
                console.log('fetching nearby sold homes!');
                this.fetchNearbySold({
                    id: this.dpp.id,
                    propertyId: this.dpp.propertyId,
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                    size: 30,
                    propertyType: this.dpp.propertyType,
                });
            }
        },
        directTo() {
            var url = 'https://www.google.com/maps/place/' + encodeURIComponent(this.dpp.geo.formatAddress);
            window.open(url);
        },
        open(mapTypeId, streetView, filter, activeMarker) {
            if (streetView && this.$refs.mapRef) {
                this.$refs.mapRef.setStreetView({
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                });
            } else if (mapTypeId && this.$refs.mapRef) {
                this.$refs.mapRef.setStreetView(null);
                this.$refs.mapRef.changeMapType(mapTypeId);
            }
            this.$refs.pop.open && this.$refs.pop.open();
        },
        close() {
            this.$refs.pop.close();
        },
        toggleStreetView() {
            if (this.$refs.mapRef?.hasActiveStreetView) {
                this.$refs.mapRef.setStreetView(null);
            } else {
                this.$refs.mapRef.setStreetView({
                    lat: this.dpp.geo.lat,
                    lng: this.dpp.geo.lng,
                });
            }
        },
        onMapReady({ api, map }) {
            const streetViewService = new api.StreetViewService();

            streetViewService.getPanorama(
                {
                    location: {
                        lat: this.dpp.geo.lat,
                        lng: this.dpp.geo.lng,
                    },
                    radius: 50,
                },
                (data, status) => {
                    if (status === api.StreetViewStatus.OK) {
                        this.streetViewAvailable = true;
                    } else {
                        this.streetViewAvailable = false;
                    }
                }
            );
        },
    },
    mounted() {
        this.$refs.pop.open && this.$refs.pop.open();
        let that = this;
        this.$eventBus.$on('propertyPopMap.schoolBoundaryUpdate', function (data) {
            if (that.dpp && that.dpp.geo && data.uId) {
                let mspSchoolUrl = that.glb.appUrl + that.dpp.geo.cityCode + '-' + that.dpp.geo.stateCode + '/saz-' + data.uId + '/';
                window.location.href = mspSchoolUrl;
            }
        });
        if (!this.getSelectedPoi.length) {
            var defaultPoiList = ['cafes', 'grocery', 'restaurants'];
            this.updateSelectedPoi(defaultPoiList);
        }
        this.fetchNearbySoldHomes();
    },
    computed: {
        ...mapGetters('glb', ['glb', 'mapType', 'mapDetails', 'getSelectedPoi']),
        ...mapGetters('dpp', ['dpp', 'getNearbyPois', 'getNearbySchools', 'getNearbySoldHomes', 'getNearbyPois']),
        ...mapGetters('msp', ['getSchoolData', 'noSchoolFilter']),
        filteredPois() {
            if (this.getNearbyPois.length > 0) {
                const flattenedList = this.getNearbyPois.reduce((acc, obj) => acc.concat(obj.list), []);
                return flattenedList.filter((poi) => this.getSelectedPoi.includes(poi.poiTypeName));
            }
            return [];
        },
        nearbyHomes() {
            let nearbyHomes = [{ ...this.dpp, isHomePin: true }];
            if (this.glb.rentals && this.dpp.isNewDpp) {
                if (this.dpp.nearbyRentHomes) {
                    nearbyHomes = nearbyHomes.concat(this.dpp.nearbyRentHomes);
                }
            } else {
                if (this.dpp.nearbyHomes) {
                    nearbyHomes = nearbyHomes.concat(this.dpp.nearbyHomes);
                }
                if (this.dpp.nearbySoldHomes) {
                    nearbyHomes = nearbyHomes.concat(this.dpp.nearbySoldHomes);
                }
            }
            return nearbyHomes;
        },
        streetViewUnavailable() {
            return this.$refs.mapRef && !this.$refs.mapRef.streetViewAvailable;
        },
    },
    beforeUnmount() {
        this.$eventBus.$off('propertyPopMap.schoolBoundaryUpdate');
    },
};
